export function doDrawImage(
  ctx,
  src,
  srcleft,
  scrtop,
  srcWidth,
  srcHeight,
  dstLeft,
  dstTop,
  destWidth,
  destHeight,
  disableSmooth
) {
  ctx.imageSmoothingEnabled = !disableSmooth;
  ctx.drawImage(src, srcleft, scrtop, srcWidth, srcHeight, dstLeft, dstTop, destWidth, destHeight);
}
